const appflow = {
  state: {
    hisList: '' || JSON.parse(localStorage.getItem('appHisList')),
    appInfo: '' || JSON.parse(localStorage.getItem('appInfo')),
    pageVisible: true,
    userInfo: '' || sessionStorage.getItem('USREINFO')
  },
  mutations: {
    SET_APPID: (state, appId) => {
      state.appId = appId
      sessionStorage.setItem('appId', JSON.stringify(appId))
    },
    SET_HISLIST: (state, hisList) => {
      state.hisList = hisList
      localStorage.setItem('appHisList', JSON.stringify(hisList))
    },
    SET_APPINFO: (state, appInfo) => {
      state.appInfo = Object.assign({}, appInfo)
      sessionStorage.setItem('appInfo', JSON.stringify(appInfo))
    },
    SET_PAGEVISIBLE: (state, pageVisible) => {
      state.pageVisible = pageVisible
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  }
}

export default appflow
